import { SCREENS } from "utils/constants";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ORGANIZATION.LAONS.BTC.LIST,
    exact: true,
    element: <List />,
  },
];

export default routes;
